<template>
  <div>
    <div class="d-flex" style="margin-bottom: 50px;" v-if="enrichmentType && currentEntity">
      <div class="logo-wrapper">
        <new-enrichment-logo :type="enrichmentType" class="picto" />
        <div>
          <span class="logo-title-wrapper">{{ $t('enrichment.' + enrichmentType + '.title') }}</span>
        </div>
      </div>

      <div class="w-100 text-end">
        <tc-entity-history v-if="currentEntity" :entity="currentEntity"></tc-entity-history>
      </div>
    </div>
  </div>
</template>
<script>
import NewEnrichmentLogo from '@components/icons/enrichment-logo.vue';
import TcEntityHistory from '@components/widgets/tc-entity-history.vue';
import { dateToDayMonthYearString, dateToHourMin } from '@common/filters/date-formatter';
import { mapState } from 'vuex';

export default {
  components: {
    NewEnrichmentLogo,
    TcEntityHistory,
  },
  computed: {
    ...mapState('enrichment/eventEnrichment', {
      currentEntity: 'entity',
    }),
    enrichmentType() {
      return this.$store.state?.enrichment?.eventEnrichment?.entity?.enrichment_type;
    },
  },
  methods: {
    capitalizeFirstLetter(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    computeCreateUpdateDate(date) {
      return date ? dateToDayMonthYearString(new Date(date)) : '-';
    },
    computeCreateUpdateTime(date) {
      return date ? dateToHourMin(new Date(date)) : '-';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@styles/variables.scss';

.logo-wrapper {
  border: 1px solid #e7e3e3;
  border-radius: 5px;
  padding: 19px 0 19px 19px;
  display: flex;
  .picto {
    font-size: 36px;
  }
  & > div {
    white-space: nowrap;
    margin-left: 30px;
    margin-right: 30px;
    .logo-title-wrapper {
      font-weight: 700;
      font-size: 14px;
      line-height: 36px;
      color: $gray-600;
    }
  }
}

.create-update-wrapper {
  color: $gray-500;
  font-size: $font-size-base;
  .create-update-title {
    text-decoration: underline;
  }
}
</style>
